import { ReactElement, ReactNode } from 'react'

export interface CircleContainerProps {
  children?: ReactNode
  color?: string
  size?: string
}

export default function CircleContainer(props: CircleContainerProps) {
  const size = props.size ?? '32px'
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        alignContent: 'center',
        justifyContent: 'center',
        width: size,
        height: size,
        minWidth: size,
        minHeight: size,
        letterSpacing: 0,
        lineHeight: undefined,
        borderRadius: '50%',
        backgroundColor: props.color,
        flexShrink: 0,
        overflow: 'hidden',
        boxSizing: 'border-box',
        padding: 1
      }}
    >
      {props.children}
    </div>
  )
}
